export default __webpack_public_path__ + "static/media/united.d2d96db2.svg";